module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("chapter 1")]), _vm._v(" "), _c('h1', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "id": "chapter01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('strong', [_vm._v("VEGETABLE ESSENTIALS")])]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap"
  }, [_c('p', {
    staticClass: "image_horiz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "auto",
      "src": "images/f0012-01.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "toc-sectop"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01sec01"
    }
  }, [_c('strong', [_vm._v("GALLERY OF ITALIAN VEGETABLES")]), _vm._v(" 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter01sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HERBS")]), _vm._v(" 41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter01sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INGREDIENTS")]), _vm._v(" 43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter01sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("EQUIPMENT")]), _vm._v(" 49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter01sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BASIC RECIPES")]), _vm._v(" 54")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter01sec05a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH EGG PASTA DOUGH 55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter01sec05b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPINACH PASTA DOUGH 58")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter01sec05c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLAKY PASTRY DOUGH 60")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter01sec05d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWEET PASTRY DOUGH 61")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter01sec05e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VEGETABLE BROTH 62")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter01sec05f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH BASIL PESTO 64")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter01sec05g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH TOMATO SAUCE 65")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter01sec05h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIMPLE TOMATO SAUCE 66")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter01sec05i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLOW-ROASTED TOMATOES 67")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter01sec05j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROASTED FENNEL 68")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter01sec05k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROASTED MUSHROOMS 69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter01sec05l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROASTED WINTER SQUASH PURÉE 70")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter01sec05m",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BASIC BEANS IN A POT 71")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter01sec05n",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GRILLED PEPPERS 74")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter01sec05o",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAUTÉED RAPINI 75")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705fd75a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06chapter01.vue
// module id = 75
// module chunks = 0